<!--珠海一格-单位概况-->
<template>
	<div class="usePowerUnitBody custom-scrollbar">
		<!-- 通用-单位信息 -->
		<yigeUnitInfo class="smallWindow smallWindowMargin"></yigeUnitInfo>
		<!-- 通用-月事件告警统计环比 -->
		<workStateNoWork class="smallWindow"></workStateNoWork>
		<!-- 通用-单位日负荷 -->
		<dayInfo class="marginTop bigWindow"></dayInfo>
		<!-- 通用-单位年统计 -->
		<yearOrMonthkWh class="marginTop bigWindow"></yearOrMonthkWh>
		<div style="height: 10px;width: 100%;"></div>
	</div>
</template>
<script>
	import yigeUnitInfo from '@/page/unitKanBan/component/yigeUnitInfo.vue'
	import workStateNoWork from '@/page/unitKanBan/component/workStateNoWork.vue'
	import dayInfo from '@/page/unitKanBan/component/dayInfo.vue'
	import yearOrMonthkWh from '@/page/unitKanBan/component/yearOrMonthkWh.vue'
	import unitStore from '@/cache/unitStore.js'
	export default {
		components: {
			yigeUnitInfo,
			workStateNoWork,
			dayInfo,
			yearOrMonthkWh,
		},
		props: [],
		data() {
			return {}
		},
		created() {

		},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.usePowerUnitBody {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		height: calc(100% - 35px);
		padding: 1%;
		overflow: auto;
	}
	
	.smallWindow {
		width: calc(50% - 6px);
		height: 270px;
	}
	
	.smallWindowMargin {
		margin-right: 8px;
	}
	
	.marginTop {
		margin-top: 8px;
	}
	
	.bigWindow {
		width: 100%;
		height: 270px;
	}
	
	@media screen and (max-width: 1200px) {
		.smallWindow {
			width: 100%;
		}
		.smallWindowMargin {
			margin-right: 0;
			margin-bottom: 8px;
		}
		.bigWindow {
			height: auto;
			min-height: 270px;
		}
	}
</style>